// @ts-nocheck c6cdd8b6
import * as actions from './windowActions';

export { actions };
